export const font = "Open Sans"
export const colors = {
    phaseBackgroundBase: "#575f65",
    phaseBackgroundTr1: "#8f9ba7",
    phaseBackgroundTr2: "#2c3138",
    phaseTextColor: "#fff",
    phaseBorderColor: "#232323",
    phaseShadowColor: "black",

    guiBorderColor: "#a9a9a9",
    guiPointColor: "#00ff00",

    arrowColor: "grey",
    arrowSelectedColor: "#fff",
}

// start/end side
export const top = 0
export const right = 1
export const bottom = 2
export const left = 3

export const gridSize = 10

export const phaseWidth = 220
export const childMarkerWidth = 15
export const inputDocumentsWidth = 40
export const outputDocumentsWidth = 45
